<template>
  <div class="mc-toast" :class="{ 'is-on': visible }">{{ message }}</div>
</template>

<script>
export default {
  name: 'Toast',
  data() {
    return {
      message: '',
      visible: false,
      hideTimer: null,
    }
  },
  beforeDestroy() {
    clearTimeout(this.hideTimer)
  },
  methods: {
    show(message) {
      this.message = message
      this.visible = true
      clearTimeout(this.hideTimer)
      this.hideTimer = setTimeout(() => {
        this.visible = false
      }, 2300)
    },
  },
}
</script>

<style scoped>
.mc-toast {
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: calc(78px + env(safe-area-inset-bottom, 0px) + 14px);
  z-index: 30;
  background: #14142b;
  color: #fff;
  font-size: 13.5px;
  font-weight: 500;
  padding: 13px 16px;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  opacity: 0;
  transform: translateY(12px);
  pointer-events: none;
  transition: 0.25s;
}

.mc-toast.is-on {
  opacity: 1;
  transform: none;
}
</style>
